import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'

/* The Marathon hero is a WebGL canvas with a 3D phone model and cannot
   render on the server, so it is loaded client-side only. A dark skeleton
   holds the layout (100svh) while the scene and model load. */
const Marathon = dynamic(
    () => import('@/components/landing/marathon/Marathon'),
    {
        ssr: false,
        loading: () => <HeroSkeleton />
    }
)

const HeroSkeleton: FC = (): ReactNode => {
    return (
        <div
            className='relative flex w-full items-center justify-center overflow-hidden bg-black'
            style={{ height: '100svh', minHeight: 640 }}
        >
            <div className='flex flex-col items-center gap-5'>
                <span className='h-9 w-9 animate-spin rounded-full border-2 border-white/15 border-t-[#E94E1B]' />
                <span className='text-[11px] font-bold tracking-[0.28em] text-white/55'>
                    LOADING THE RUN
                </span>
            </div>
        </div>
    )
}

export const HeroMarathon: FC = (): ReactNode => {
    return <Marathon />
}
